<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { NodeData } from '../types/flow-types';
	import { getFlowCardDefinition } from '../core/card-engine/registry';

	export let id: string;
	export let data: NodeData;
	export let selected = false;
	export let validated = true;
	export let errors: string[] = [];

	$: definition = getFlowCardDefinition('virtualComponentAction', String(data.paletteKey || ''));
	$: summary = definition?.summary(data) || 'Configure virtual component';
</script>

<BaseNode
	{id}
	type="virtualComponentAction"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={summary}
	nodeTypeLabel={data.paletteKey === 'emitVirtualButtonEvent'
		? 'Emit virtual button event'
		: 'Set virtual component'}
	{...$$restProps}
/>
